import 'jquery';
import {plenigoLog} from './logger';

/**
 * see https://docs.payone.com/pages/releaseview.action?pageId=1214523
 *
 *
 */

(function ($, Payone) {
  var form = $('form[data-submit="payone"]');

  if (!form.length) {
    return;
  }

  var styles,
    iframes,
    config,
    response,
    request = form.data('config'),
    // vanilla event handling
    eventMethod = (window.addEventListener ? 'addEventListener' : 'attachEvent'),
    eventer = window[eventMethod],
    messageEvent = (eventMethod === 'attachEvent' ? 'onmessage' : 'message'),
    supportedCardtypes = form.data('supported-cardtypes') || ['V', 'M', 'J', 'A'],
    payoneResponse = function (payoneResponse) {
      // put response in our static response and run in our form submit again
      response = payoneResponse;
      if (response.status === 'VALID') {
        form.submit();
      } else {
        form.trigger('plenigo.reset');
        form.find('#errorMessage').addClass('has_errors');
      }
      $(document).trigger('plenigo.resize');
    },
    events = {
      // /**
      //  * Called whenever a field is ready to get rendered
      //  * @param data
      //  * @constructor
      //  */
      // READY: function (data) {
      //   // data.message: ''
      // },
      // /**
      //  * Called for every field, if we're ale to input
      //  * @param data
      //  * @constructor
      //  */
      // RENDERED: function (data) {
      //   // data.message: { field: 'cardexpiremonth' }
      // },
      // /**
      //  * called whenever an input is made
      //  * @param data
      //  * @constructor
      //  */
      // VALUE: function (data) {
      //   // data.message: { type: 'cardcvc2', value: '123' }
      //   console.log('VALUE');
      //   console.log(data);
      // },
      // /**
      //  * seems to be never called
      //  * @param data
      //  * @constructor
      //  */
      // FOCUS: function (data) {
      //   console.log('FOCUS');
      //   console.log(data);
      // },
      /**
       * called on every keyup
       * data.message:
       *  isCardTypeComplete: true
       isCardpanComplete: false
       isComplete: false
       isCvcComplete: true
       isExpireMonthComplete: false
       isExpireYearComplete: false
       * @param data
       * @constructor
       */
      IS_COMPLETE: function (data) {
        var message = data.message,
          input = $('#payoneCheck');

        $('span.form-control').removeClass('filled');

        if (data.message.isCardpanComplete) {
          $('#cc-number').addClass('filled');
        }

        if (data.message.isCvcComplete) {
          $('#cc-cvv').addClass('filled');
        }

        if (data.message.isExpireMonthComplete || data.message.isExpireYearComplete) {
          $('#cc-expiration').addClass('filled');
        }

        if (message.isComplete) {
          input.val('completed');
          // form.find(':submit:first').focus();
        } else {
          input.val('');
        }
        input.trigger('change');
      },
      // /**
      //  * all other events are called here
      //  * @param data
      //  * @constructor
      //  */
      // SOMETHING_ELSE: function (data) {
      // },
    },
    dispatch = function (e) {
      var data = {};

      // we have to check the events origin to prevent side effects with 3rd party scripts
      // we have name of iframe
      // Todo: check the origin
      // return;
      try {
        data = JSON.parse(e.data);
        if ('object' !== typeof data) {
          return;
        }
      } catch (e) {
        // disabled because of endless loop problem
        // plenigoLog.error('failed while recieving data from Payone', { error: e.message });
        return;
      }

      if ('Payone' === data.origin && 'string' === typeof data.event && 'function' === typeof events[data.event]) {
        // we're confronted with billions of events, here we filter all calls from our iframes child
        events[data.event](data);
      }
    };

  // Payone.ClientApi.Language.de.placeholders.cardpan = 'Karten Nr.';
  // Payone.ClientApi.Language.de.placeholders.cvc = 'Prüfziffer';
  // Payone.ClientApi.Language.de.placeholders.expireMonth = '(MM)';
  // Payone.ClientApi.Language.de.placeholders.expireYear = '(JJJJ)';


  /*

  // Some overwriting and placeholder enabling examples.

  // Example for enabling placeholder attribute in <input type='text' /> fields.
  // Defaults to empty, so placeholder will not be applied.
  Payone.ClientApi.Language.de.placeholders.cardpan = 'Kartennummer';
  Payone.ClientApi.Language.de.placeholders.cvc = 'CVC';
  // Please keep in mind: placeholders are not supported for input type “select”.
  Payone.ClientApi.Language.de.placeholders.expireMonth = '(MM)';
  Payone.ClientApi.Language.de.placeholders.expireYear = '(JJJJ)';

  // Example for overwriting error messages in english.
  Payone.ClientApi.Language.en.invalidCardpan: 'your error text';
  Payone.ClientApi.Language.en.invalidCvc: 'your error text';
  Payone.ClientApi.Language.en.invalidPanForCardtype: 'your error text';
  Payone.ClientApi.Language.en.invalidCardtype: 'your error text';
  Payone.ClientApi.Language.en.invalidExpireDate: 'your error text';
  Payone.ClientApi.Language.en.invalidIssueNumber: 'your error text';
  Payone.ClientApi.Language.en.transactionRejected: 'your error text';

  // Example for overwriting default month i18n in english (instead of 1, 2, 3 etc.)
  Payone.ClientApi.Language.en.months.month1 = 'January';
  Payone.ClientApi.Language.en.months.month2 = 'February';
  Payone.ClientApi.Language.en.months.month3 = 'March';

  */

  if (!form.length) {
    return;
  }

  styles = 'font-family:Helvetica;font-size: 16px; border: none; color: #29293a;width:100%;display:inline-block;height:25px;outline: none;';
  config = {
    fields: {
      cardpan: {
        selector: 'cc-number',
        type: 'input',
        inputmode: 'numeric',
        autocomplete: 'on',
      },
      cardcvc2: {
        selector: 'cc-cvv',
        type: 'text',  // Could be 'text' as well.
        size: '4',
        // This is a configuration example for something like:
        // * Amex: Exactly 4 digits.
        // * Visa: Exactly 3 digits.
        // * JCB: No CVC, input disabled.
        // * Mastercard: Not configured, up to maxlength digits or none.
        // Notice that our validation code should be stable with case insensitive configurations made by
        // the merchant. This is why we have a lower case 'a' and an upper case 'V' and 'J' for this demo
        // configuration.
        maxlength: '4',
        length: {'a': 4, 'V': 3, 'J': false, 'M': 3},
      },
      cardexpiremonth: {
        selector: 'cc-expiration-month',
        type: 'text', // select (default), text, tel (for alternative keyboards on mobile devices)
        size: '2',
        maxlength: '2',
        minlength: '2',
        style: styles + 'text-align:right;',
      },
      cardexpireyear: {
        selector: 'cc-expiration-year',
        size: '4',
        maxlength: '4',
        minlength: '4',
        type: 'text', // select (default), text, tel (for alternative keyboards on mobile devices)
      },
      cardtype: {
        selector: 'cc-type',
        cardtypes: supportedCardtypes,
      },
    },
    defaultStyle: {
      input: styles,
      styleFocus: styles,
      select: 'font-size: 1em; border: 1px solid #000;',
      iframe: {
        height: '20px',
        width: '100%',
      },
    },

    autoCardtypeDetection: {
      supportedCardtypes: supportedCardtypes,
      callback: function (detectedCardtype) {
        // Individual callback code starts here:
        iframes.setCardType(detectedCardtype);
        // Individual callback code ends.
      }, //,
      // deactivate: true // To turn off automatic card type detection.
      // Must be explicitly set to boolean true.
    },

    events: {
      // Javascript callback function will be triggered once “hosted iFrames” are completely loaded
      rendered: function () {
        // plenigoLog.info('render PayOne form', {});

      },
    },

    // Todo: get language from
    language: Payone.ClientApi.Language.de, //, // Language to display error-messages (default: Payone.ClientApi.Language.en)
    error: 'errorMessage', // area to display error-messages (optional)
  };

  // request = {
  //   request: 'creditcardcheck',                  // fixed value
  //   responsetype: 'JSON',                        // fixed value
  //   mode: 'test',                                // desired mode
  //   mid: '45538',                                // your MID
  //   aid: '45610',                                // your AID
  //   portalid: '2033046',                         // your PortalId
  //   encoding: 'UTF-8',                           // desired encoding
  //   storecarddata: 'yes',                        // fixed value
  //   // hash calculated over your request-parameter-values (alphabetical request-order) plus PMI portal key
  //   // hash: '1cf456bf692453613ebb992a3fb859cc347ddc7e94e2ca764efbe8b0089de6964ab1266df0831e59de89dc5291070fe7'
  //   hash: '1265bcf0c38742b1b606eb09284bd351',
  // };

  if (typeof Payone === 'undefined') {
    plenigoLog.error('Payone Object not found', {});
    return;
  }

  try {
    // create the payone part of our form
    iframes = new Payone.ClientApi.HostedIFrames(config, request);
  } catch (e) {
    plenigoLog.error('Payone Object not created', {exception: e.message});
  }

  // the whole magic is put in the submit event
  form.on('submit', function (e) {
    // 1st remove all error messages
    form.find('#errorMessage').removeClass('has_errors');

    // okay, we're ready to completely submit the form
    if (typeof response === 'object' && response.status === 'VALID') {
      form.find('input[data-payone-field]').each(function () {
        // key in payone syntax
        var key = $(this).data('payone-field');
        if (response[key]) {
          $(this).val(response[key]);
        }
      });
      return true;
    }

    // prevent our form from being submitted
    e.preventDefault();

    // We're missing something. Schould show some error messages
    if (!iframes.isComplete()) {
      // and now we should enable the form
      e.stopPropagation();
      plenigoLog.error('Payone iframe is not complete created', {});
    }

    // everything is filled right, we perform the the payone server call
    else {
      // Perform 'CreditCardCheck' to create and get a PseudoCardPan; then call your function 'payCallback'
      iframes.creditCardCheck('payoneCallback');
    }
  });

  // callback we want to be called if we want to get a response from payone
  window.payoneCallback = payoneResponse;

  eventer(messageEvent, dispatch, false);

}(jQuery, (window.Payone || null)));
